var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0C0.358172 0 0 0.358172 0 0.8C0 1.24183 0.358172 1.6 0.8 1.6H9.6C10.0418 1.6 10.4 1.24183 10.4 0.8C10.4 0.358172 10.0418 0 9.6 0H0.8Z",
    fill: "#767681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 3.2C0.358172 3.2 0 3.55817 0 4C0 4.44183 0.358172 4.8 0.8 4.8H6.4C6.84183 4.8 7.2 4.44183 7.2 4C7.2 3.55817 6.84183 3.2 6.4 3.2H0.8Z",
    fill: "#767681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 6.4C0.358172 6.4 0 6.75817 0 7.2C0 7.64183 0.358172 8 0.8 8H4C4.44183 8 4.8 7.64183 4.8 7.2C4.8 6.75817 4.44183 6.4 4 6.4H0.8Z",
    fill: "#767681"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4C10.4 3.55817 10.0418 3.2 9.6 3.2C9.15818 3.2 8.8 3.55817 8.8 4L8.8 8.46863L7.76569 7.43431C7.45327 7.1219 6.94674 7.12189 6.63432 7.43431C6.3219 7.74673 6.3219 8.25327 6.63432 8.56569L9.03432 10.9657C9.18435 11.1157 9.38783 11.2 9.6 11.2C9.81218 11.2 10.0157 11.1157 10.1657 10.9657L12.5657 8.56569C12.8781 8.25327 12.8781 7.74673 12.5657 7.43432C12.2533 7.1219 11.7467 7.1219 11.4343 7.43432L10.4 8.46863L10.4 4Z",
    fill: "#767681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.bda732d1666901a93be769fa43e375c8.svg";
export { ForwardRef as ReactComponent };